import React, {useEffect, useState} from 'react';
import {
  ActivityIndicator,
  FlatList,
  TouchableOpacity,
  View,
} from 'react-native';
import MultiCard from '../../home/childComponents/multiCard';

import {connect} from 'react-redux';
import Colors from '../../../assets/Color/Colors';
import NoMarket from '../../../commonComponents/NoMarkets';

import {getLuckyCoinEvents} from '../redux/rewards.action';
import ParentProbeCard from '../../home/childComponents/parentProbeCard';
import {globalImport} from '../../../common/globalImports';
import {isMobile} from '../../../utils/commonMethods';
import {RefreshControl} from 'react-native-web-refresh-control';
import {Color} from '../../../assets';

const RewardsEvents = ({
  navigation,
  eventsData,
  rewardsDetailsLoading,
  getLuckyCoinEvents,
  contestStartTime,
}) => {
  const [mulitOptionList, setMultiOptionList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const onCardClick = item => {
    navigation.navigate('Event', {
      eventId: item.id,
      isMulti: item.parent_id === -1 ? true : false,
    });
  };

  useEffect(() => {
    PullToRefresh();
  }, []);

  const PullToRefresh = async () => {
    setIsLoading(true);
    await getLuckyCoinEvents();
    setIsLoading(false);
  };

  const renderProbeCard = ({item, index}) => {
    return (
      <TouchableOpacity
        style={{flex: 1}}
        onPress={() => onCardClick(item)}
        delayPressIn={0}
        key={item.id}>
        {item?.parent_id === -1 ? (
          <MultiCard
            trade={item}
            mulitOptionList={mulitOptionList[item.id]}
            onCallback={() => {
              onCardClick(item);
            }}
            contestStartTime={contestStartTime}
            timerExpireCallback={() => {
              //timerExpireCallback(item);
            }}
          />
        ) : (
          <ParentProbeCard
            trade={item}
            onCallback={() => {
              onCardClick(item);
            }}
            contestStartTime={contestStartTime}
            timerExpireCallback={() => {
              //timerExpireCallback(item);
            }}
          />
        )}
      </TouchableOpacity>
    );
  };

  const handleEmpty = () => {
    return <NoMarket innerContestCondition={true} source="contest_events" />;
  };

  const renderFooter = () => {
    return (
      <View
        style={{
          padding: 10,
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'row',
        }}>
        {rewardsDetailsLoading ? (
          <ActivityIndicator size="large" color={Colors.black} />
        ) : null}
      </View>
    );
  };

  useEffect(() => {
    if (eventsData?.probes) {
      const multiOptionFilter = {};
      const filteredProbeList = eventsData?.probes.filter(item => {
        if (item.parent_id >= 1) {
          if (
            multiOptionFilter.length > 0 &&
            multiOptionFilter[item.parent_id]?.length > 0
          ) {
            if (multiOptionFilter[item.parent_id]?.length < 2)
              multiOptionFilter[item.parent_id].push(item);
          } else {
            multiOptionFilter[item.parent_id] = [item];
          }
        }
      });
      setMultiOptionList(multiOptionFilter);
    }
  }, [eventsData]);

  return (
    <View style={{marginTop: 15}}>
      <FlatList
        scrollEnabled={true}
        data={eventsData?.probes}
        renderItem={renderProbeCard}
        keyExtractor={(item, index) => item.id}
        showsVerticalScrollIndicator={false}
        initialNumToRender={10}
        //getItemLayout={getItemLayoutFun}
        updateCellsBatchingPeriod={15}
        //maxToRenderPerBatch={4}

        contentContainerStyle={[
          {
            paddingBottom: eventsData?.probes?.length > 0 ? 350 : 0,
          },
        ]}
        //columnWrapperStyle={{ flex: 1 }}
        ListEmptyComponent={handleEmpty}
        onRefresh={PullToRefresh}
        refreshing={rewardsDetailsLoading}
        ListFooterComponent={globalImport.isWeb ? renderFooter : <></>}
        refreshControl={
          isMobile() ? (
            <RefreshControl
              colors={[Color.tradexBlue]}
              refreshing={isLoading}
              onRefresh={PullToRefresh}
            />
          ) : null
        }
      />
    </View>
  );
};

const mapStateToProps = ({rewardsReducer}) => ({
  eventsData: rewardsReducer.rewardsEventsData,
  rewardsDetailsLoading: rewardsReducer.rewardsDetailsLoading,
});
const mapDispatchToProps = {
  getLuckyCoinEvents,
};

export default connect(mapStateToProps, mapDispatchToProps)(RewardsEvents);
